import { jsx as _jsx } from "react/jsx-runtime";
import { Image as ChakraImage, } from '@chakra-ui/react';
/**
 * Renders an image with support for fallbacks.
 *
 * @see Docs https://bit.cloud/caspeco/casper-ui-library/components/image
 */
export function Image({ ...props }) {
    return _jsx(ChakraImage, { ...props });
}
//# sourceMappingURL=image.js.map